
import { defineComponent, ref, watch } from "vue";
import ApiService from "@/core/services/ApiService";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import EditApplicationModal from "@/components/modals/general/EditApplicationModal.vue";
import { useStore } from "vuex";
import SmsMessageModal from "@/components/modals/general/SmsMessageModal.vue";
import IboEmailModal from "@/components/modals/general/IboEmailModal.vue";

export default defineComponent({
  name: "admin-application-drawer",
  emits: ["submit"],
  props: {
    merchant: { type: Object, required: true },
    app_id: String,
  },
  components: {
    EditApplicationModal,
    SmsMessageModal,
    IboEmailModal,
  },
  setup(props, { emit }) {
    const filesHiddenTotal = ref(0);
    const applicationFilesTotal = ref(0);
    const filesHidden = ref([]);
    const applicationFiles = ref([]);
    const loading = ref(false);
    const fileHistory = ref([]);
    const fileHistoryTotal = ref([]);
    const loadingHistory = ref(false);
    const taskResetLoading = ref(false);
    const fileDeleteLoading = ref(false);
    const store = useStore();

    watch(
      () => props.app_id,
      async () => {
        if (props.app_id) {
          await getHiddenFiles();
          await getApplicationFiles();
          await getFileHistory();
        }
      }
    );

    const getApplicationFiles = async () => {
      loading.value = true;
      const res2 = await ApiService.get(
        `img/ibo_files?app_id=${props.app_id}&filestatus=1`
      );
      applicationFiles.value = res2.data.data;
      applicationFilesTotal.value = res2.data.meta.total;

      loading.value = false;
    };
    const getHiddenFiles = async () => {
      loading.value = true;
      const res = await ApiService.get(
        `img/ibo_files?app_id=${props.app_id}&filestatus=0`
      );
      filesHidden.value = res.data.data;
      filesHiddenTotal.value = res.data.meta.total;
      loading.value = false;
    };
    const getFileHistory = async () => {
      loading.value = true;
      const res = await ApiService.get(
        `dashboard/activities?event_path=/v3/imgupload&admin_id=${store.getters.currentUser.data.adminid}`
      );
      fileHistory.value = res.data.data;
      fileHistoryTotal.value = res.data.meta.total;
      loadingHistory.value = false;
    };
    const checked = ref(false);

    const onHideFile = async (index, val) => {
      let payload: any = "";
      loading.value = true;
      try {
        const res = await ApiService.put(
          `img/ibo_files/${index}?filestatus=${val}`,
          payload
        );
        if (res.data.success) {
          Swal.fire({
            text: "Visibility updated",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            getApplicationFiles();
            getHiddenFiles();
            getFileHistory();
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
      loading.value = false;
    };
    const onReviewFile = async (index, val) => {
      let payload: any = "";
      taskResetLoading.value = true;
      try {
        const res = await ApiService.put(
          `img/ibo_files/${index}?reviewed=${val}`,
          payload
        );
        if (res.data.success) {
          Swal.fire({
            text: "File Updated",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            getApplicationFiles();
            getHiddenFiles();
            getFileHistory();

            emit("submit");
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
      taskResetLoading.value = false;
    };
    const onDeleteFile = async (index) => {
      fileDeleteLoading.value = true;
      try {
        const res = await ApiService.delete(`img/ibo_files/${index}`);
        if (res.data.success) {
          Swal.fire({
            text: "File Deleted!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            getApplicationFiles();
            getHiddenFiles();
            getFileHistory();
            emit("submit");
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
      fileDeleteLoading.value = false;
    };
    const onUpdateIboApplication = () => {
      getApplicationFiles();
    };
    return {
      onReviewFile,
      onDeleteFile,
      onHideFile,
      applicationFiles,
      filesHidden,
      filesHiddenTotal,
      fileHistory,
      fileHistoryTotal,
      applicationFilesTotal,
      checked,
      fileDeleteLoading,
      taskResetLoading,
      loadingHistory,
      onUpdateIboApplication,
    };
  },
});
